import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const QuoteProductInput = () => {
  const { productId = '' } = useParams();
  const decodedId = productId ? atob(productId) : productId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'quoteProduct';

  useEffect(() => {
    if (productId) { setIsEditing(true); fetchDetails(); }
  }, [productId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.quoteProduct}${id}/`, { headers });
      setFormData(response.data);
    } catch (error) {
      console.error('Error fetching product details:', error);
    }
  };

  const fields = [
    { name: 'name', label: 'Product Name', type: 'text' },
    { name: 'sku', label: 'SKU', type: 'text' },
    { name: 'price', label: 'Price', type: 'number' },
    { name: 'category', label: 'Category', type: 'text' },
    {
      name: 'unit_of_measure', label: 'Unit of Measure', type: 'select',
      options: [
        { value: 'piece', label: 'Piece' },
        { value: 'kg', label: 'Kilogram (kg)' },
        { value: 'litre', label: 'Litre' },
        { value: 'hour', label: 'Hour' },
        { value: 'day', label: 'Day' },
        { value: 'month', label: 'Month' },
        { value: 'license', label: 'License' },
        { value: 'subscription', label: 'Subscription' },
        { value: 'other', label: 'Other' },
      ],
    },
    { name: 'unit_price', label: 'Unit Price', type: 'number' },
    { name: 'stock_quantity', label: 'Stock Quantity', type: 'number' },
    { name: 'minimum_order_qty', label: 'Minimum Order Quantity', type: 'number' },
    { name: 'tax_rate', label: 'Tax Rate (%)', type: 'number' },
    { name: 'image_url', label: 'Image URL', type: 'text' },
    { name: 'description', label: 'Description', type: 'textarea' },
    { name: 'is_active', label: 'Is Active', type: 'checkbox' },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Product' : 'Create Product'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default QuoteProductInput;
